export enum ExportTypeEnum {
  MemberExport = 'memberExport',
  MemberSnapshot = 'memberSnapshot',
  MemberList = 'memberListExport',
  BookKeepingRecordExport = 'bookKeepingRecordExport',
  AddressLabelExport = 'addressLabelExport',
  AutogiroMandate = 'autogiroMandate',
  depositExport = 'depositExport',
  SmsBillingReport = 'smsBillingReport',
  BirthdayList = 'birthdayListExport',
}
